export default __webpack_public_path__ + "static/media/sampleDock.0dc98c7d.jpg";